import { useQuery } from '@tanstack/react-query'

import axios from '@/_lib/axiosInstance'
import { ApiResponse, IAmbulance } from '@/_types'

/**
 * Loads a public ambulance record by URL slug (used to resolve id for product and category queries).
 *
 * @param slug - Unencoded slug segment from the route or selection step.
 */
export const fetchAmbulanceBySlug = async (slug: string): Promise<ApiResponse<IAmbulance>> => {
	return axios
		.get<ApiResponse<IAmbulance>>(`v1/web/clinic/ambulances/${encodeURIComponent(slug)}`)
		.then(res => res.data)
}

/**
 * React Query hook for {@link fetchAmbulanceBySlug}; disabled for empty slugs.
 *
 * @param slug - Ambulance slug from the URL or `null` when not yet known.
 */
export const useGetAmbulance = (slug: string | null) => {
	return useQuery<ApiResponse<IAmbulance>>({
		queryKey: ['ambulance', 'slug', slug],
		queryFn: () => fetchAmbulanceBySlug(slug!),
		enabled: !!slug && slug.length > 0,
		select: data => data
	})
}
